module.exports = __webpack_public_path__ + "img/Villa_Borna_57.de919e05.jpg";